"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_EMAIL_TEMPLATE_KINDS = void 0;
exports.SYSTEM_EMAIL_TEMPLATE_KINDS = {
    fundraising: "engagement",
    invitation: "engagement",
    progress_update: "update",
    event_update: "update",
    general_update: "update",
    reminder: "update",
    thank_you: "thank_you",
    event_recap: "thank_you",
    event_recap_next_event: "thank_you",
    newsletter: "newsletter",
    newsletter_blog: "newsletter",
    newsletter_donation_appeal: "newsletter",
    newsletter_donor_recognition: "newsletter",
    newsletter_multi_column: "newsletter",
    newsletter_annual_report: "newsletter",
    empty: null,
    from_scratch: null,
};
